import type { FC } from 'react';

import type { IconProps } from './type';

export const RubiesFilledIcon: FC<IconProps> = ({ ...props }) => {
  return (
    <svg
      data-id="rubies-filled-icon"
      fill="none"
      height={23}
      width={22}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M10.773 22.195c5.95 0 10.773-4.928 10.773-11.008 0-6.08-4.823-11.008-10.773-11.008C4.823.179 0 5.107 0 11.187c0 6.08 4.823 11.008 10.773 11.008Zm1.097-15.91 1.046 3.169H8.659l1.045-3.168h2.166ZM4.315 9.455l2.317-3.168h2.242L7.83 9.454H4.315Zm10.627-3.168 2.317 3.168h-3.513L12.7 6.286h2.242ZM11.57 17.217l2.37-6.963h3.32l-5.69 6.963Zm1.53-6.952-2.306 7.093-2.34-7.093H13.1Zm-3.115 6.92-5.658-6.931h3.32l2.338 6.93Z"
        fill="#9209E2"
        fillRule="evenodd"
      />
    </svg>
  );
};
